// extracted by mini-css-extract-plugin
export default {"Image":"Image-module__Image__IjBxI","ImageLoaded":"Image-module__ImageLoaded__ZE40E"};